import Footer from './components/footer.jsx';
import Header from './components/header.jsx'; 
import Content from './components/content.jsx';
import './App.css';

function App() {
  return (
    <main>
      <Header />
      <Content/>
      <Footer />
    </main>
  );
}

export default App;
